import script from "./shipmentListTab.vue?vue&type=script&setup=true&lang=js"
export * from "./shipmentListTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__